module.exports = __webpack_public_path__ + "static/favicon-180-touch-1738352f9789ab5091da1b79e1d89769.png";